module.exports = __webpack_public_path__ + "img/2gcciu63.569aba5a.png";